module.exports = __webpack_public_path__ + "img/chanceoffreezingrain.8bdf47fe.png";